import { onRoomRequestedChanged } from 'owa-calendar-compose-form-actions';
import loc from 'owa-localize';
import { confirm, DialogResponse } from 'owa-confirm-dialog';

export default async function (
    isRoomRequested: boolean,
    dialogTitle: string,
    dialogDescription: string,
    acceptCallback: () => void,
    formId: string,
    targetWindow: Window
) {
    if (
        isRoomRequested &&
        (await confirm(loc(dialogTitle), loc(dialogDescription), false, {
            delayCallbackAfterAnimation: true,
            targetWindow: targetWindow,
        })) == DialogResponse.ok
    ) {
        onRoomRequestedChanged(false, formId);
        acceptCallback();
    } else if (!isRoomRequested) {
        acceptCallback();
    }
}
